export default __webpack_public_path__ + "static/media/graphHelpBtn.2fb943de.svg";